<template>
	<div>
		<div class="container">
			<div class="row justify-content-center pt-4">
				<div class="col-12 col-xxl-10 text-center mt-5 mb-2">
					<h1 class="mb-3">Registrati per partecipare al progetto</h1>
					<p>
						Registrandoti avrai la possibilità di partecipare al progetto, scaricare materiali informativi e ricevere aggiornamenti sulle future proposte educative di Fondazione Umberto Veronesi.
					</p>
				</div>
			</div>

			<form method="POST" id="reg-form" class="pb-5 font-roboto-sans" @submit.prevent="submitRegistrationForm">
				<div class="row mt-4">

					<div class="col-lg-6 px-xl-5">
						<h2 class=" my-4">Dati docente</h2>

						<div class="row">
							<div class="col-12 form-group">
								<input type="text" name="nome" id="nome" class="form-control form-control-lg control-border-bottom" placeholder="Nome*" required autocomplete="aut_off_iuasdsvkz" maxlength="150" v-model="form.name">
							</div>

							<div class="col-12 form-group">
								<input type="text" name="cognome" id="cognome" class="form-control form-control-lg control-border-bottom" placeholder="Cognome*" required autocomplete="aut_off_iuasdsvkz" maxlength="150" v-model="form.lastname">
							</div>

							<div class="col-12 form-group mb-1">
								<input type="email" name="e-mail" id="e-mail" class="form-control form-control-lg control-border-bottom mb-0" placeholder="Email*" required  autocomplete="aut_off_iuasdsvkz" maxlength="150" v-model="form.email">
							</div>
							<div class="col-12 text-left mb-2" style="line-height:0.7;">
								<small for="e-mail" class="mb-0 fs-0-7">La mail con cui ti registri è anche l’username con cui potrai accedere alla tua area riservata.</small>
							</div>

							<div class="col-12 form-group">
								<input type="text" name="tel" id="tel" class="form-control form-control-lg control-border-bottom" placeholder="Telefono*" required autocomplete="aut_off_iuasdsvkz" maxlength="100" v-model="form.tel">
							</div>

							<div class="col-12 form-group">
								<input type="text" name="materia" id="materia" class="form-control form-control-lg control-border-bottom" placeholder="Materia insegnata*" required autocomplete="aut_off_iuasdsvkz" maxlength="100" v-model="form.materia">
							</div>

							<div class="col-12 form-group">
								<span>* Campi obbligatori</span>
							</div>
						</div>
					</div>

					<div class="col-lg-6 px-xl-5">
						<h2 class=" mt-4">Dati scuola</h2>
						<p class="mb-4">Cerca la tua scuola usando i filtri qui sotto.</p>

						<!-- <div class="row">
							<div class="col-12 form-group input-group input-group-lg">
								<select name="regio-filter" id="regio-filter" class="form-control form-control-lg custom-select" v-model="selected.grado" @change="populateRegionSelect" required>
									<option value=""><span class="color-blue-light">SELEZIONA GRADO SCUOLA*</span></option>
									<option value="1">SCUOLA SECONDARIA I GRADO</option>
									<option value="2">SCUOLA SECONDARIA II GRADO</option>
								</select>
							</div>
						</div> -->

						<div class="row">
							<div class="col-12 form-group input-group input-group-lg">
								<select name="regio-filter" id="regio-filter" class="form-control form-control-lg custom-select" v-model="selected.region" @change="populateProvinceSelect" required>
									<option value=""><span class="color-blue-light">SELEZIONA REGIONE*</span></option>
									<option :value="region.regione" v-for="(region, index) in selects.regions" :key="index">{{region.regione}}</option>
								</select>
							</div>

							<div class="col-12 form-group input-group input-group-lg">
								<select name="prov-filter" id="prov-filter" class="form-control form-control-lg custom-select" v-model="selected.province" @change="populateCitiesSelect" required>
									<option value="">SELEZIONA PROVINCIA*</option>
									<option :value="province.provincia + '|' + province.provincia_sigla" v-for="(province, index) in selects.provinces" :key="index">{{province.provincia}}</option>
								</select>
							</div>

							<div class="col-12 form-group input-group input-group-lg">
								<select name="com-filter" id="com-filter" class="form-control form-control-lg custom-select" v-model="selected.city" @change="populateSchoolSelect" required>
									<option value="">SELEZIONA COMUNE*</option>
									<option :value="city.citta" v-for="(city, index) in selects.cities" :key="index">{{city.citta}}</option>
								</select>
							</div>

							<div class="col-12 form-group input-group input-group-lg">
								<select name="com-filter" id="com-filter" class="form-control form-control-lg custom-select" v-model="selected.school" @change="showSelectedSchool" required>
									<option value="">SELEZIONA SCUOLA*</option>
									<option :value="school.IDist" v-for="(school, index) in selects.schools" :key="index">{{school.nome}}</option>
								</select>
							</div>

							<div class="col-12 my-3" v-if="showNotify">
								<div class="notify py-1">
									<small>Non sei riuscito a trovare la tua scuola? Clicca <a href="#" @click.prevent="showEmailModal" class="bold">QUI</a> per segnalarcelo!
									Inseriremo al più presto la tua scuola e verrai ricontattato appena disponibile.</small>
								</div>
							</div>
						</div>

						<div class="row m-0">
							<div class="col-12" v-if="Object.keys(showingSchool).length != 0"><small class="bold">Scuola selezionata</small></div>
							<div class="col-12 form-group bg-light-grey rounded py-2" v-if="Object.keys(showingSchool).length != 0">
								<div>
									Scuola: {{showingSchool.nome}}<br>
									Indirizzo: {{showingSchool.indirizzo}}
								</div>
							</div>
						</div>

						<div class="row">
							<div class="col-12 form-group input-group input-group-lg" v-if="showSubType && schoolIsSelected">
								<select name="com-filter" id="com-filter" class="form-control form-control-lg custom-select" v-model="selected.schoolType" :required="showSubType">
									<option value="">SELEZIONA TIPO SCUOLA*</option>
									<option value="4">LICEO</option>
									<option value="5">ISTITUTO TECNICO</option>
									<option value="6">ISTITUTO PROFESSIONALE</option>
								</select>
							</div>
						</div>
					</div>

					<div id="add-cls" class="col-lg-6 offset-lg-6 px-xl-5" v-if="schoolIsVisible">
						<div class="pt-2 pb-3">
							<div class="row align-items-center">
								<div class="col-12 mb-2"><span class="">Aggiungi una o più classi*</span></div>
								<div class="col-md-3 form-group input-group input-group-lg mt-2">
									<select name="classi" id="classi" class="form-control form-control-lg custom-select" v-model="selected.class" @change="msg.clsError = ''">
										<option :value="value.no" v-for="(value, index) in classes.slice(0, limitClasses)" :key="index">{{value.class}}</option>
									</select>
								</div>

								<div class="col-md-3 form-group input-group input-group-lg mt-2">
									<select name="sezioni" id="sezioni" class="form-control form-control-lg custom-select" v-model="selected.classLetter" @change="msg.clsError = ''">
										<option value="A">A</option>
										<option value="B">B</option>
										<option value="C">C</option>
										<option value="D">D</option>
										<option value="E">E</option>
										<option value="F">F</option>
										<option value="G">G</option>
										<option value="H">H</option>
										<option value="I">I</option>
										<option value="L">L</option>
										<option value="M">M</option>
										<option value="N">N</option>
										<option value="O">O</option>
										<option value="P">P</option>
										<option value="Q">Q</option>
										<option value="R">R</option>
										<option value="S">S</option>
										<option value="T">T</option>
										<option value="U">U</option>
										<option value="V">V</option>
										<option value="Z">Z</option>
									</select>
								</div>

								<div class="col-md-6 form-group input-group input-group-lg text-right mt-2">
									<button role="button" type="button" id="btn-add-cls" class="btn btn-blk rounded-pill px-2" @click.prevent="addSelectdClass">
										<span class="va-m">AGGIUNGI</span>
									</button>
								</div>

								<div class="col-12">
									<small class="red-text">{{msg.clsError}}</small>
								</div>

							</div>

							<div class="row" v-if="selectedClassesList.length > 0">
								<div class="col-12">
									<div class="row">
										<div class="col-12"><small class="bold">Classi selezionate</small></div>

										<div class="col-12 class-row" v-for="(cls, index) in selectedClassesList" :key="index">
											<div class="class-row-item">
												<div class="row align-items-center">
													<div class="col-9">
														<span class="mr-3">{{cls.class}}</span> <span>{{cls.letter}}</span>
													</div>
													<div class="col text-center"><i class="fas fa-times va-m" @click.prevent="removeClass(index)"></i></div>
												</div>
											</div>
										</div>
									</div>
								</div>
							</div>

						</div>
					</div>

					<div class="col-lg-6 offset-lg-6 px-xl-5 d-school d-school-none">
						<div class="row">
							<div class="col-12 form-group custom-form-check mt-2">
								<input id="prvc" class="checkbox-custom" name="prvc" type="checkbox" required v-model="form.privacy">
								<label for="prvc" class="checkbox-custom-label fs-0-7 lh-1">
									<span>*  Ho preso visione delle <a :href="themeUrl + 'pdf/doc/Informazioni_ex_art_13.pdf'" target="_blank" class=" bold">informazioni ex art. 13, GDPR </a></span>
									<span>Per qualsiasi dubbio in merito al trattamento dei dati personali, è possibile rivolgersi ai recapiti indicati nell’informativa ovvero</span> <a class="bold" href="mailto:info@fondazioneveronesi.it">info@fondazioneveronesi.it</a>
								</label>
							</div>
						</div>
					</div>

					<div class="col-lg-6 offset-lg-6 px-xl-5 d-school d-school-none">
						<div class="row">
							<div class="col-12 form-group custom-form-check mt-0">
								<input id="prvc-info" class="checkbox-custom" name="prvc" type="checkbox" required v-model="form.privacyInfo">
								<label for="prvc-info" class="checkbox-custom-label fs-0-7">
									<span>* Ho letto e compreso l’incarico affidato e accetto la <a :href="themeUrl + '/pdf/doc/Contratto_di_nomina_di_responsabile_del_trattamento_per_il_docente.pdf'" target="_blank" class=" bold">nomina di responsabile</a></span>
								</label>
							</div>
						</div>
					</div>
					<div class="col-lg-6 offset-lg-6 px-xl-5 d-school d-school-none">
						<div class="row">
							<div class="col-12 form-group custom-form-check mt-1">
								<input id="reg-info" class="checkbox-custom" name="reg-info" type="checkbox" required v-model="form.regolamento">
								<label for="reg-info" class="checkbox-custom-label fs-0-7">
									<span>* Ho letto e accetto il <a :href="themeUrl + 'pdf/regolamento-fumo-e-altre-stories.pdf'" target="_blank" class=" bold">Regolamento*</a></span>
								</label>
							</div>
						</div>
					</div>

					<div class="col-lg-6 offset-lg-6 px-xl-5 text-right mt-2 mb-3 d-school d-school-none">
						<button type="submit" id="sub-teach" class="btn btn-blk rounded-pill btn-lg px-4" value="INVIA" :disabled="form.showLoader"><span>REGISTRATI ORA</span> <i class="fas fa-circle-notch fa-spin ml-1" :class="{'d-none': !form.showLoader}"></i></button>
					</div>

				</div>

				<div class="row justify-content-center">
					<div class="col-lg-8 col-xl-6">
						<div class="msg-result fs-1-5 text-center bold" v-html="msg.msgForm"></div>
					</div>
				</div>
			</form>

		</div>

		<modal name="school-add"
			height="auto"
			:adaptive=true
		> <!-- ** Modal ************************* -->
			<div class="p-3">
				<form id="email-form" @submit.prevent="submitSchoolNotify">
					<div class="container">
						<div class="row">
							<div class="col-12 text-right"><i class="fas fa-times hover-default fs-1-5" @click.prevent="hideEmailModal"></i></div>
						</div>
						<div class="row">
							<div class="col-12 mb-3"><h5>Segnalaci la tua scuola</h5></div>
							<div class="col-12 form-group">
								<input type="text" name="nome-cognome" id="nome-cognome" class="form-control form-control-lg" placeholder="Nome e/o Cognome*" required autocomplete="aut_off_iuasdsvkz" maxlength="150" v-model="emailForm.namelastname">
							</div>
							<div class="col-12 form-group">
								<input type="email" name="email-notify" id="email-notify" class="form-control form-control-lg" placeholder="Latua email*" required autocomplete="aut_off_iuasdsvkz" maxlength="150" v-model="emailForm.email">
							</div>
							<div class="col-12 form-group">
								<input type="text" name="nome-scuola" id="nome-scuola" class="form-control form-control-lg" placeholder="Nome scuola*" required autocomplete="aut_off_iuasdsvkz" maxlength="150" v-model="emailForm.name">
							</div>
							<div class="col-12 form-group">
								<input type="text" name="citta-scuola" id="citta-scuola" class="form-control form-control-lg" placeholder="Comune scuola*" required autocomplete="aut_off_iuasdsvkz" maxlength="150" v-model="emailForm.city">
							</div>
							<div class="col-12 form-group">
								<input type="text" name="mec-cod" id="mec-cod" class="form-control form-control-lg" placeholder="Codice meccanografico" autocomplete="aut_off_iuasdsvkz" maxlength="150" v-model="emailForm.mecCod">
							</div>
							<div class="col-12 my-1" v-if="emailForm.msgModalForm">
								<div class="text-center" v-html="emailForm.msgModalForm"></div>
							</div>
							<div class="col-lg-6 offset-lg-6 text-right mt-2 mb-3">
								<button type="submit" id="sub-notify" class="btn btn-blk rounded-pill btn-sm px-5" value="INVIA" :disabled="emailForm.showLoaderModal"><span>INVIA</span> <i class="fas fa-circle-notch fa-spin" :class="{'d-none': !emailForm.showLoaderModal}"></i></button>
							</div>
						</div>
					</div>
				</form>
			</div>
		</modal>

	</div>
</template>

<script>
// import jQuery from 'jquery'
import Vue from 'vue'
import axios from 'axios'
import {urlBase, themeDir} from '../../variables'
import VModal from 'vue-js-modal'
Vue.use(VModal, { dialog: true })
const jQuery = window.jQuery

export default {
	name: 'TeacherRegistrationComponent',
	data() {
		return {
			ajaxObj: window.ajax_object,
			selects: {
				regions: {},
				provinces: {},
				cities: {},
				schools: {}
			},
			selected: {
				grado: '1',
				region: '',
				province: '',
				city: '',
				class: '1',
				classLetter: 'A',
				school: '',
				schoolType: ''
			},
			form: {
				name: '',
				lastname: '',
				email: '',
				tel: '',
				materia: '',
				privacy: false,
				privacyInfo: false,
				showLoader: false,
				regolamento: false
			},
			selectedClassesList: [],
			showingSchool: {},
			classes: [
				{
					class: '1',
					no: 1
				},
				{
					class: '2',
					no:2
				},
				{
					class: '3',
					no:3
				},
				{
					class: '4',
					no: 4
				},
				{
					class: '5',
					no: 5
				}
			],
			limitClasses: 0,
			schoolIsVisible: false,
			themeUrl: urlBase + themeDir,
			msg: {
				clsError: '',
				msgForm: ''
			},
			showSubType: false,
			schoolIsSelected: false,
			showNotify: false,
			emailForm: {
				name: '',
				mecCod: '',
				city: '',
				email: '',
				namelastname: '',
				showLoaderModal: false,
				msgModalForm: ''
			}
		}
	},

	watch: {
		'selects.schools': function (newObi) {
			if(Object.keys(newObi).length == 0) {
				this.selectedClassesList = []
				this.showingSchool = {}
			}
		},
		'selected.school': function() {
			this.selectedClassesList = []
		}
	},

	methods: {
		populateRegionSelect() {
			this.showSubType = this.selected.grado == '2' ? true : false
			this.selects.regions = {}
			this.selects.cities = {}
			this.selects.provinces = {}
			this.selects.schools = {}
			this.selected.region = ''
			if(this.selected.grado != '') {
				this.limitClasses = (this.selected.grado == 1) ? 3 : 5

				let url = this.ajaxObj.ajax_url
				var data = new FormData();
				data.append('action', 'nl_pop_reg')
				data.append('_nounce_value', this.ajaxObj._nounce_value)
				data.append('grado', this.selected.grado)

				axios.post(url, data)
					.then((response) => {
						// console.log(response.data)
						this.selects.regions = response.data
						this.selected.province = ''
						this.selected.city = ''
						this.selected.class = '1'
						this.selected.school = ''
						this.schoolIsVisible = false
					}, (error) => {
						console.log(error);
						this.selected.region = ''
						this.selected.province = ''
						this.selected.city = ''
						this.schoolIsVisible = false
					});
			} else {
				this.selected.region = ''
				this.selected.province = ''
				this.selected.city = ''
				this.selected.class = '1'
				this.selected.school = ''
				this.schoolIsVisible = false
				this.limitClasses = 0
			}
		},
		populateProvinceSelect() {
			this.selects.cities = {}
			this.selects.schools = {}
			if(this.selected.region != '') {
				let url = this.ajaxObj.ajax_url
				var data = new FormData();
				data.append('action', 'nl_pop_prov')
				data.append('_nounce_value', this.ajaxObj._nounce_value)
				data.append('region', this.selected.region)
				data.append('grado', this.selected.grado)

				axios.post(url, data)
					.then((response) => {
						this.selects.provinces = response.data
						this.selected.province = ''
						this.selected.city = ''
						this.selected.school = ''
						this.schoolIsVisible = false
					}, (error) => {
						console.log(error);
					});
			} else {
				this.selected.province = ''
				this.selected.city = ''
				this.selected.school = ''
				this.schoolIsVisible = false
				this.selects.provinces = {}
				this.selects.cities = {}
				this.selects.schools = {}
			}
		},
		populateCitiesSelect() {
			this.selects.schools = {}
			if(this.selected.province != '') {
				let url = this.ajaxObj.ajax_url
				var data = new FormData();
				data.append('action', 'nl_pop_com')
				data.append('_nounce_value', this.ajaxObj._nounce_value)
				data.append('province', this.selected.province)
				data.append('grado', this.selected.grado)

				axios.post(url, data)
					.then((response) => {
						this.selects.cities = response.data
						this.selected.city = ''
						this.selected.school = ''
						this.schoolIsVisible = false
					}, (error) => {
						console.log(error);
					});
			} else {
				this.selected.city = ''
				this.selected.school = ''
				this.schoolIsVisible = false
				this.selects.cities = {}
				this.selects.schools = {}
			}
		},
		populateSchoolSelect() {
			this.showingSchool = {}
			if(this.selected.city != '') {
				this.showNotify = true
				let url = this.ajaxObj.ajax_url
				var data = new FormData();
				data.append('action', 'nl_get_schools')
				data.append('_nounce_value', this.ajaxObj._nounce_value)
				data.append('city', this.selected.city)
				data.append('grado', this.selected.grado)

				axios.post(url, data)
					.then((response) => {
						this.selects.schools = response.data
						this.selected.school = ''
						this.schoolIsVisible = false
					}, (error) => {
						console.log(error);
					});
			} else {
				this.showNotify = false
				this.selected.school = ''
				this.selects.schools = {}
				this.schoolIsVisible = false
			}
		},
		showSelectedSchool() {
			if(this.selected.school != '') {
				this.schoolIsSelected = true
				this.showingSchool = this.selects.schools.find(obj => {
					return obj.IDist === this.selected.school
				})

				this.schoolIsVisible = true
			} else {
				this.schoolIsSelected = false
				this.showingSchool = {}
				this.schoolIsVisible = false
			}

		},
		addSelectdClass() {
			this.msg.clsError = ''
			let arrayRow = {
				class: this.selected.class,
				letter: this.selected.classLetter
			}
			const rowExists = this.selectedClassesList.some(x => x.class === this.selected.class && x.letter === this.selected.classLetter)
			if (rowExists) {
				this.msg.clsError = 'Attenzione: hai già inserito questa classe!'
			} else {
				this.selectedClassesList.push(arrayRow)
			}
		},
		removeClass(index) {
			let arr = this.selectedClassesList;
			arr.splice(index, 1);
			this.selectedClassesList = arr;
			this.msg.clsError = ''
		},

		submitRegistrationForm() {
			let url = this.ajaxObj.ajax_url
			this.msgForm = ''
			this.form.showLoader = true

			var data = new FormData();
			data.append('action', 'nl_submit_school')
			data.append('_nounce_value', this.ajaxObj._nounce_value)
			data.append('nome', this.form.name)
			data.append('cognome', this.form.lastname)
			data.append('email', this.form.email)
			data.append('tel', this.form.tel)
			data.append('privacy', this.form.privacy)
			data.append('materia', this.form.materia)
			data.append('selected_school', this.selected.school)
			data.append('selected_classes', JSON.stringify(this.selectedClassesList))
			data.append('provincia', this.selected.province)
			data.append('citta', this.selected.city)
			data.append('school_type', this.selected.schoolType)

			axios.post(url, data)
				.then((response) => {
					// console.log(response.data)
					if(response.data.error == '') {
						this.resetForm()
						this.msg.msgForm = response.data.msg
					} else {
						this.msg.msgForm = response.data.error
					}
					this.form.showLoader = false
				}, (error) => {
					console.log(error);
					this.form.showLoader = false
				});
		},
		resetForm() {
			this.selects = {
				regions: {},
				provinces: {},
				cities: {},
				schools: {}
			}
			this.selected = {
				grado: '1',
				region: '',
				province: '',
				city: '',
				class: '1',
				classLetter: 'A',
				school: ''
			}
			this.form = {
				name: '',
				lastname: '',
				email: '',
				tel: '',
				materia: '',
				privacy: false
			}
			this.selectedClassesList = []
			this.showingSchool = {}
			this.limitClasses = 0
			this.schoolIsVisible = false
			this.msg = {
				clsError: ''
			}
			this.showNotify = false
			this.showSubType = false
			this.schoolIsSelected = false
			window.scrollTo(0, document.body.scrollHeight || document.documentElement.scrollHeight);
		},

		showEmailModal () {
			this.emailForm.email = this.form.email
            this.$modal.show('school-add');
        },

		hideEmailModal() {
			this.emailForm = {
				name: '',
				mecCod: '',
				city: '',
				namelastname: ''
			}
			this.$modal.hide('school-add');
		},

		submitSchoolNotify() {
			let url = this.ajaxObj.ajax_url

			this.emailForm.msgModalForm = ''
			this.emailForm.showLoaderModal = true

			var data = new FormData();
			data.append('action', 'nl_new_school_notify')
			data.append('_nounce_value', this.ajaxObj._nounce_value)
			data.append('nome', this.emailForm.namelastname)
			data.append('email', this.emailForm.email)
			data.append('city', this.emailForm.city)
			data.append('mec_cod', this.emailForm.mecCod)
			data.append('school_name', this.emailForm.name)

			axios.post(url, data)
				.then((response) => {
					// console.log(response.data)
					this.emailForm.showLoaderModal = false
					if(response.data.error == '') {
						this.emailForm.msgModalForm = response.data.msg

						this.emailForm.namelastname = ''
						this.emailForm.email = ''
						this.emailForm.city = ''
						this.emailForm.mecCod = ''
						this.emailForm.name = ''
					} else {
						this.emailForm.msgModalForm = response.data.error
					}
				}, (error) => {
					this.emailForm.showLoaderModal = false
					console.log(error);
				});
		}
	},

	mounted() {
		jQuery(document).ready(function($) {
			$('.login-menu-item').addClass('current-menu-item');
		})
		this.populateRegionSelect()
	}
}
</script>

<style scoped>
.notify {
	border-top: 1px solid #000;
	border-bottom: 1px solid #000;
}
</style>
